

import { createUseStyles } from 'react-jss';
import colors from "../../utils/colors";

var styles = {
  tableWrapper: function tableWrapper(_ref) {var width = _ref.width;return {
      width: width || '100%'
    };},
  table: {
    boxSizing: 'border-box',
    font: {
      family: ['Lato', 'sans-serif']
    },
    borderCollapse: 'collapse',
    border: 'none',
    tableLayout: 'fixed',
    position: 'relative',
    overflowX: 'auto',
    width: '100%'
  },
  paginationController: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '11rem',
    padding: '0.5rem 0rem',
    margin: { left: 'auto' }
  },
  pageNumbers: {
    font: {
      size: '1.8rem',
      lineHeight: '2.4rem',
      weight: 600
    },
    letterSpacing: '0.02rem',
    color: colors.neutral[900]
  },
  inputPageWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  paginationWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  inputTitle: {
    font: {
      size: '1.8rem',
      lineHeight: '2.4rem',
      weight: 600
    },
    letterSpacing: '0.02rem',
    color: colors.neutral[900],
    marginRight: '2rem'
  },
  inputPage: {
    '& p': {
      position: 'absolute',
      bottom: '-3rem',
      whiteSpace: 'nowrap'
    }
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map